import { useDutchPrice } from './useDutchPrice'
import { useMinimumBid } from './useMinimumBid'

export const useAuctionPrice = () => {
  const minimumBid = useMinimumBid()
  const dutchPrice = useDutchPrice()
  return dutchPrice ?? minimumBid
}
